export type StoppageTypeWithReason =
  | 'cementMill'
  | 'rawMill'
  | 'coalMill'
  | 'crusher'
  | 'rollerPress'
  | 'verticalMill'
  | 'ballMill'
  | 'dosingEquipment'
  | 'bypass'
  | 'other'
  /**
   * Note: reason is only supported for old alternativeFuelInstallation stoppages
   * which already have a reason. New stoppages should always be created with a code.
   */
  | 'alternativeFuelInstallation'

export type StoppageTypeWithCode = 'kiln' | 'cementMill' | 'rawMill' | 'alternativeFuelInstallation'
export type StoppageType = 'kiln' | StoppageTypeWithReason

export const FormStoppageType = {
  Kiln: 'kiln',
  CementMill: 'cementMill',
  RawMill: 'rawMill',
  CoalMill: 'coalMill',
  Crusher: 'crusher',
  AlternativeFuelInstallation: 'alternativeFuelInstallation',
  Bypass: 'bypass',
  Other: 'other'
} as const
export type FormStoppageType = (typeof FormStoppageType)[keyof typeof FormStoppageType]

export const FormStoppageTypeWithDepartments = {
  Kiln: FormStoppageType.Kiln,
  CementMill: FormStoppageType.CementMill,
  RawMill: FormStoppageType.RawMill,
  CoalMill: FormStoppageType.CoalMill,
  Crusher: FormStoppageType.Crusher
} as const
export type FormStoppageTypeWithDepartments =
  (typeof FormStoppageTypeWithDepartments)[keyof typeof FormStoppageTypeWithDepartments]
